import { createGlobalStyle } from 'styled-components';

import VTEXTrust from '../assets/VTEXTrustFull-VF.woff2';

export default createGlobalStyle`
@font-face {
  font-family: VTEXTrust;
  src: url(${VTEXTrust}) format("woff2");
  font-weight: normal;
  font-size: normal;
}

html {
  scroll-behavior: smooth;
}

* {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    font-weight: 400;
    line-height: 125%;
  }

  *:focus {
    outline: 0;
  }

  html, body, #root {
    height: 100%;
    font-size: 10px;
  }

  body {
    background: #fff;
    -webkit-font-smoothing: antialiased;
  }

  body, input, button {
    // you can change
    font-family: 'VTEXTrust', sans-serif;
  }

  a {
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
  }
`;
